import React from "react"
import styled from "styled-components"
import _ from "lodash"

import automationService from "data/automation"
import ConfirmationModal from "components/modal/confirmation-modal"

type DeleteConfirmProps = {
  show: boolean
  close: Function
  confirm: Function
  code: string
  snapshotButtonText: string
  snapshotFunc: Function
}

const DeletePropConfirmation = (props: DeleteConfirmProps) => {
  return (
    <ConfirmationModal
      height={100}
      width={600}
      contentHeight={50}
      show={props.show}
      toggleShow={props.close}
      title={"Delete Confirmation"}
      confirmText={"Delete"}
      message={""}
      confirmFunc={props.confirm}
      cancelFunc={props.close}
      confirmOnly={false}
      closeOnly={false}
      tertiary={true}
      tertiaryText={props.snapshotButtonText}
      tertiaryFunc={props.snapshotFunc}
      >
        {`Deleting Property: ${props.code} cannot be undone.  Would you like to snapshot the Property first so that you can restore it later?`}
    </ConfirmationModal>
  )
}

export default DeletePropConfirmation
